// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Image Carousel Styles */
.image-carousel {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.carousel-image:hover {
  transform: scale(1.02);
}

.carousel-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 30px 20px 20px;
  color: white;
}

.carousel-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: white;
}

.carousel-description {
  font-size: 0.9rem;
  line-height: 1.4;
  margin: 0;
  opacity: 0.9;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Navigation Arrows */
.carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-nav:hover {
  background: rgba(255, 255, 255, 1);
  transform: translateY(-50%) scale(1.1);
}

.carousel-prev {
  left: 15px;
}

.carousel-next {
  right: 15px;
}

/* Dots Indicator */
.carousel-dots {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 2;
}

.carousel-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-dot:hover {
  border-color: rgba(255, 255, 255, 0.8);
}

.carousel-dot.active {
  background: white;
  border-color: white;
}

/* Loading and Error States */
.carousel-loading,
.carousel-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 1.1rem;
  color: #666;
  background: #f5f5f5;
}

.carousel-error {
  color: #e74c3c;
}

/* Image Popup Modal */
.image-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  cursor: pointer;
}

.image-popup-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: default;
}

.image-popup-close {
  position: absolute;
  top: -50px;
  right: -10px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-popup-close:hover {
  background: white;
  transform: scale(1.1);
}

.image-popup-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.image-popup-info {
  margin-top: 20px;
  text-align: center;
  color: white;
  max-width: 600px;
}

.image-popup-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: white;
}

.image-popup-description {
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  opacity: 0.9;
}

/* Responsive Design */
@media (max-width: 768px) {
  .image-carousel {
    height: 300px;
  }
  
  .carousel-title {
    font-size: 1.2rem;
  }
  
  .carousel-description {
    font-size: 0.8rem;
    -webkit-line-clamp: 1;
    line-clamp: 1;
  }
  
  .carousel-nav {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  
  .carousel-prev {
    left: 10px;
  }
  
  .carousel-next {
    right: 10px;
  }
  
  .carousel-dot {
    width: 10px;
    height: 10px;
  }
  
  .image-popup-close {
    top: -40px;
    right: 0;
    width: 35px;
    height: 35px;
    font-size: 20px;
  }
  
  .image-popup-title {
    font-size: 1.3rem;
  }
  
  .image-popup-description {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .image-carousel {
    height: 250px;
  }
  
  .carousel-overlay {
    padding: 20px 15px 15px;
  }
  
  .carousel-title {
    font-size: 1.1rem;
  }
  
  .carousel-description {
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageCarousel.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4DAA4D;EAC5D,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Image Carousel Styles */\n.image-carousel {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  overflow: hidden;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.carousel-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.carousel-slide {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.carousel-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.carousel-image:hover {\n  transform: scale(1.02);\n}\n\n.carousel-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));\n  padding: 30px 20px 20px;\n  color: white;\n}\n\n.carousel-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  color: white;\n}\n\n.carousel-description {\n  font-size: 0.9rem;\n  line-height: 1.4;\n  margin: 0;\n  opacity: 0.9;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Navigation Arrows */\n.carousel-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.carousel-nav:hover {\n  background: rgba(255, 255, 255, 1);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.carousel-prev {\n  left: 15px;\n}\n\n.carousel-next {\n  right: 15px;\n}\n\n/* Dots Indicator */\n.carousel-dots {\n  position: absolute;\n  bottom: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 8px;\n  z-index: 2;\n}\n\n.carousel-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.carousel-dot:hover {\n  border-color: rgba(255, 255, 255, 0.8);\n}\n\n.carousel-dot.active {\n  background: white;\n  border-color: white;\n}\n\n/* Loading and Error States */\n.carousel-loading,\n.carousel-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  font-size: 1.1rem;\n  color: #666;\n  background: #f5f5f5;\n}\n\n.carousel-error {\n  color: #e74c3c;\n}\n\n/* Image Popup Modal */\n.image-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  cursor: pointer;\n}\n\n.image-popup-container {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: default;\n}\n\n.image-popup-close {\n  position: absolute;\n  top: -50px;\n  right: -10px;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-popup-close:hover {\n  background: white;\n  transform: scale(1.1);\n}\n\n.image-popup-image {\n  max-width: 100%;\n  max-height: 70vh;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.image-popup-info {\n  margin-top: 20px;\n  text-align: center;\n  color: white;\n  max-width: 600px;\n}\n\n.image-popup-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 10px 0;\n  color: white;\n}\n\n.image-popup-description {\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 0;\n  opacity: 0.9;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .image-carousel {\n    height: 300px;\n  }\n  \n  .carousel-title {\n    font-size: 1.2rem;\n  }\n  \n  .carousel-description {\n    font-size: 0.8rem;\n    -webkit-line-clamp: 1;\n    line-clamp: 1;\n  }\n  \n  .carousel-nav {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n  \n  .carousel-prev {\n    left: 10px;\n  }\n  \n  .carousel-next {\n    right: 10px;\n  }\n  \n  .carousel-dot {\n    width: 10px;\n    height: 10px;\n  }\n  \n  .image-popup-close {\n    top: -40px;\n    right: 0;\n    width: 35px;\n    height: 35px;\n    font-size: 20px;\n  }\n  \n  .image-popup-title {\n    font-size: 1.3rem;\n  }\n  \n  .image-popup-description {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .image-carousel {\n    height: 250px;\n  }\n  \n  .carousel-overlay {\n    padding: 20px 15px 15px;\n  }\n  \n  .carousel-title {\n    font-size: 1.1rem;\n  }\n  \n  .carousel-description {\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
